import type React from 'react';
import { Navigate } from 'react-router-dom';
import { PATH } from '@/router/PATH';
import { AccountingStartStepView } from './AccountingStartStepView';
import {
    useAccountingStartStep,
    type UseAccountingStartStepOptions,
} from './useAccountingStartStep';

export type AccountingStartStepProps = UseAccountingStartStepOptions;

/**
 * `/onboarding/accounting`: only while the organisation needs an accounting
 * start; otherwise it opens Branch (the strip shows Accounting skipped). The
 * year comes from the wizard's page, which keeps it while the owner goes
 * back to Welcome.
 */
export const AccountingStartStep: React.FC<AccountingStartStepProps> = ({
    year,
    onYearChange,
}) => {
    const { isNotNeeded, ...step } = useAccountingStartStep({
        year,
        onYearChange,
    });

    if (isNotNeeded) {
        return <Navigate replace to={PATH.ONBOARDING_STEP.BIND('branch')} />;
    }

    return <AccountingStartStepView {...step} />;
};
